// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer_footer__1WetU","row1":"footer_row1__313TL","icons":"footer_icons__3UNPQ","author":"footer_author__WkeBA"};